import { Injectable } from '@angular/core';
import { AnswerByCategory } from '../services/client/model/answerByCategory';
import { User } from '../services/client/model/user';
import { PollAnswer } from './client';
import { APIService } from './client/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnswersRepositoryService {

  pollAnswer: PollAnswer;
  answers: AnswerByCategory[] = [];
  user: User;
  finalComments: string;

  categoryIndex: number;

  constructor(private apiService: APIService) { }

  addUser(newUser: User) {
    this.user = newUser;
  }

  addAnswer(newAnswer: AnswerByCategory) {
    if (!this.answeredCategory(newAnswer.category_id)) {
      this.answers.push(newAnswer);
    }
    else {
      const categoryToUpadte = this.answers.findIndex(answer => answer.category_id === newAnswer.category_id);
      this.answers[categoryToUpadte] = newAnswer;
    }
  }

  answeredCategory(categoryId: number): boolean {
    return this.answers.some(answer => answer.category_id === categoryId);
  }

  postAnswer(): Observable<any> {
    this.pollAnswer = {
      user: this.user,
      answersByCategory: this.answers,
      finalComments: this.finalComments
    };
    return this.apiService.answerPost(this.pollAnswer);
  }

  getPreviousAnswers(categoryId: number): AnswerByCategory {
    return this.answers.find(answer => answer.category_id === categoryId && answer);
  }

}
